import React, { useEffect, useRef } from 'react';
// components
import {
  FixedValueAsyncSelectLookup,
  FixedValueInput,
  FixedValueSelectEnum,
  FixedValueSelectLookup,
  FixedValueToggle,
} from './controls';
import BaseDatePicker from 'shared/inputs/datePickers/BaseDatePicker';
// constants
import { mappingPropertyType } from './constants';

const FixedValueComponent = ({
  fixedValueProps, name, value, displayValue, setFieldValue, setDisplayValue, defaultValue, readOnly,
}) => {
  const { type, isAsync } = fixedValueProps;

  if (type == mappingPropertyType.date) {
    return (
      <BaseDatePicker
        name={name}
        value={value}
        defaultValue={defaultValue}
        onChange={({ value }) => setFieldValue(value)}
        readOnly={readOnly}
      />
    );
  }

  if (
    type === mappingPropertyType.integer
    || type == mappingPropertyType.decimal
    || type == mappingPropertyType.string
  ) {
    return (
      <FixedValueNumberComponent
        type={type}
        name={name}
        value={value}
        setFieldValue={setFieldValue}
        defaultValue={defaultValue}
        readOnly={readOnly}
      />
    );
  }

  if (type === mappingPropertyType.enum) {
    return (
      <FixedValueSelectEnum
        fixedValueProps={fixedValueProps}
        name={name}
        value={value}
        setFieldValue={setFieldValue}
        defaultItem={defaultValue}
        readOnly={readOnly}
      />
    );
  }

  if (isAsync && type === mappingPropertyType.lookup) {
    return (
      <FixedValueAsyncSelectLookup
        fixedValueProps={fixedValueProps}
        name={name}
        value={value}
        displayValue={displayValue}
        defaultItem={defaultValue}
        setFieldValue={setFieldValue}
        setDisplayValue={setDisplayValue}
        readOnly={readOnly}
      />
    );
  }

  if (type === mappingPropertyType.lookup) {
    return (
      <FixedValueSelectLookup
        fixedValueProps={fixedValueProps}
        name={name}
        value={value}
        defaultItem={defaultValue}
        setFieldValue={setFieldValue}
        readOnly={readOnly}
      />
    );
  }

  if (type === mappingPropertyType.boolean) {
    return (
      <FixedValueToggle
        name={name}
        value={value}
        defaultValue={defaultValue}
        setFieldValue={setFieldValue}
        readOnly={readOnly}
      />
    );
  }

  return null;
};

const FixedValueNumberComponent = (props) => {
  const inputRef = useRef(null);

  useEffect(() => {
    const handleWheel = (event) => {
      if (document.activeElement === inputRef.current?._input) {
        event.preventDefault();
      }
    };

    const inputElement = inputRef.current?._input;
    if (inputElement) {
      inputElement?.addEventListener?.('wheel', handleWheel);
    }

    return () => {
      if (inputElement) {
        inputElement?.removeEventListener?.('wheel', handleWheel);
      }
    };
  }, []);

  return (
    <FixedValueInput
      {...props}
      ref={inputRef}
    />
  );
};

export default FixedValueComponent;
